module.exports = {
  // 出精値引区分
  deliveryDiscount: [
    { code: 'enum_1', value: '1', text: '出精値引10%' },
    { code: 'enum_2', value: '2', text: '出精値引8%' },
  ],

  //見積到着区分
  estimateArrival: [
    { code: 'enum_1', value: '1', text: '到着' },
    { code: 'enum_0', value: '0', text: '未着' },
  ],

  //調査内容区分
  investigationContent: [
    { code: 'enum_1', value: '1', text: 'アスベスト含調査' },
    { code: 'enum_2', value: '2', text: '給排水管調査診断' },
    { code: 'enum_3', value: '3', text: '建物調査診断' },
    { code: 'enum_4', value: '4', text: '電気設備調査診断' },
    { code: 'enum_5', value: '5', text: 'その他調査診断' },
  ],

  //データ種別区分
  dataTypeList: [
    { code: 'enum_1', value: '1', text: '案件終了を含む' },
    { code: 'enum_2', value: '2', text: '案件中止を含む' },
  ],
  // 未実施区分
  unimplementNewClass: [
    { code: 'enum_01', value: '01', text: '不在' },
    { code: 'enum_02', value: '02', text: '辞退' },
    { code: 'enum_03', value: '03', text: '空室' },
  ],
}
